WiseMetering.Model.Circuit = WiseMetering.Model.extend({
    urlRoot: '/circuits',

    actuator: function() {
        return WiseMetering.actuators.get(this.get('actuator_id'));
    },

    actuatorName: function() {
        return this.actuator()?.get('name');
    },

    site: function() {
        return this.zone().site();
    },

    children: function() {
        return new WiseMetering.Collection(this.indicators().models.reverse());
    },

    currentMonth: function() {
        try {
            const year = moment().year(), month = moment().month();
            return this.get('data').active_energy[year][month];
        } catch (e) {
            return null;
        }
    },

    currentYear: function() {
        try {
            const year = moment().year();
            return this.get('data').active_energy[year].reduce((acc, value) => acc + value, 0);
        } catch (e) {
            return null;
        }
    },

    fullPath: function() {
        let path = [this.get('name')], parent = this.parent();

        while (parent) {
            path.unshift(parent.get('name'));
            parent = parent.parent();
        }

        return path.join(' > ');
    },

    icon: function() {
        let icon = this.tag().get('system_category_name').toLowerCase().split(' ').join('_');
        if (WiseMetering.icons[icon]) {
            return icon;
        } else {
            return 'circuits';
        }
    },

    indicator: function() {
        return this.indicators().first();
    },

    indicators: function() {
        return new WiseMetering.Collection.Indicators(WiseMetering.indicators.where({ parent_id: this.id }));
    },

    nodeUrl: function(skipSearch) {
        return `/circuits/${this.get('id')}${skipSearch ? '' : location.search}`;
    },

    parent: function() {
        const parentId = this.get('parent_id'),
            rootObject = WiseMetering.rootObjects.findWhere({ site_id: parentId, slug: 'circuits' });

        return rootObject || WiseMetering.zones.get(parentId);
    },

    searchString: function() {
        const site = this.site();
        const tag = this.tag();

        let search = site.get('name');
        search += ` ${site.tagNames().join(' ')}`;
        search += ` ${this.get('name')}`;
        search += ` ${tag.get('name')}`;

        return search;
    },

    type: function() {
        return 'circuit';
    },

    zone: function() {
        return WiseMetering.zones.get(this.get('parent_id'));
    },

    tag: function() {
        return WiseMetering.circuitTags.get(this.get('tag_id'));
    }
});
